import React, { Component } from 'react'
import { Formik, Form } from 'formik'
import ElementsDataService from '../../api/entitiesDataServices/ElementsDataService.js'
import AuthenticationService from '../general/AuthenticationService.js'
import CurrencyInput from 'react-currency-input-field'

class DomicilioFormularioComponent extends Component {
    constructor(props) {
        super(props)
        this.state = {
            id: this.props.match.params.id,
            tipoVialidad: 'Calle',
            calle: '', colonia: '', cp: '', estado: '', municipio: '',
            numeroExt: '', numeroInterior: '', telefono: '',
            estatus: '', control: '', tipo: '', tipoInmueble: '',
            referencias: '', especificaciones: '',
            entreCalle1: '', entreCalle2: '',
            contratoArrendamientoFile: '', comprobanteDomicilioFile: '',
            croquisFile: '', idArrendadorFile: '', documentoAcreditacionPosesionFile: '',
            resumenContrato: '', fechaVencimientoContrato: '', rentaMensual: '',
            notas: '', formaPago: '', noCuenta: '',
            arrendadorName: '', propietarioIntermediario: '',
            fechaInactivo: '', fechaAlta: '',
            loading: false, errors: {},
        }
        this.onSubmit = this.onSubmit.bind(this)
    }

    componentDidMount() {
        if (!AuthenticationService.haveAuthorization("WRITE_DOMICILIOS")) {
            alert("Usuario no autorizado")
            this.props.history.push('/login')
            return
        }
        if (Number(this.props.match.params.id) === -1) return

        ElementsDataService.retrieveElement("domicilios", this.state.id)
            .then(r => this.setState({
                calle: r.data.calle || '', tipoVialidad: r.data.tipoVialidad || 'Calle',
                colonia: r.data.colonia || '', cp: r.data.cp || '',
                estado: r.data.estado || '', municipio: r.data.municipio || '',
                numeroExt: r.data.numeroExt || '', numeroInterior: r.data.numeroInterior || '',
                telefono: r.data.telefono || '', estatus: r.data.estatus || '',
                control: r.data.control || '', tipo: r.data.tipo || '',
                tipoInmueble: r.data.tipoInmueble || '',
                referencias: r.data.referencias || '', especificaciones: r.data.especificaciones || '',
                entreCalle1: r.data.entreCalle1 || '', entreCalle2: r.data.entreCalle2 || '',
                contratoArrendamientoFile: r.data.contratoArrendamientoFileUrl || '',
                comprobanteDomicilioFile: r.data.comprobanteDomicilioFileUrl || '',
                croquisFile: r.data.croquisFileUrl || '',
                resumenContrato: r.data.resumenContrato || '',
                fechaVencimientoContrato: r.data.fechaVencimientoContrato || '',
                rentaMensual: r.data.rentaMensual || '',
                notas: r.data.notas || '', formaPago: r.data.formaPago || '',
                noCuenta: r.data.noCuenta || '', arrendadorName: r.data.arrendadorName || '',
                idArrendadorFile: r.data.idArrendadorFileURL || '',
                propietarioIntermediario: r.data.propietarioIntermediario || '',
                documentoAcreditacionPosesionFile: r.data.documentoAcreditacionPosesionURL || '',
                fechaInactivo: r.data.fechaInactivo || '', fechaAlta: r.data.fechaAlta || '',
            }))
    }

    validate() {
        const s = this.state
        const e = {}
        if (!s.calle) e.calle = 'Requerido'
        if (!s.numeroExt) e.numeroExt = 'Requerido'
        if (!s.colonia) e.colonia = 'Requerido'
        if (!s.cp) e.cp = 'Requerido'
        if (!s.municipio) e.municipio = 'Requerido'
        if (!s.estado) e.estado = 'Requerido'
        if (!s.estatus) e.estatus = 'Requerido'
        if (!s.control) e.control = 'Requerido'
        if (!s.tipo) e.tipo = 'Requerido'
        this.setState({ errors: e })
        return Object.keys(e).length === 0
    }

    onSubmit() {
        if (!this.validate()) return
        this.setState({ loading: true })
        const s = this.state
        const fd = new FormData()
        const up = (k, v) => fd.append(k, v)
        up('calle', s.calle.toUpperCase()); up('tipoVialidad', s.tipoVialidad)
        up('numeroExt', s.numeroExt.toUpperCase()); up('numeroInterior', s.numeroInterior.toUpperCase())
        up('municipio', s.municipio.toUpperCase()); up('estado', s.estado.toUpperCase())
        up('colonia', s.colonia.toUpperCase()); up('cp', s.cp)
        up('telefono', s.telefono); up('estatus', s.estatus)
        up('control', s.control); up('tipo', s.tipo)
        up('referencias', s.referencias.toUpperCase()); up('especificaciones', s.especificaciones.toUpperCase())
        up('tipoInmueble', s.tipoInmueble.toUpperCase())
        up('entreCalle1', s.entreCalle1.toUpperCase()); up('entreCalle2', s.entreCalle2.toUpperCase())
        up('contratoArrendamientoFile', s.contratoArrendamientoFile)
        up('comprobanteDomicilioFile', s.comprobanteDomicilioFile)
        up('croquisFile', s.croquisFile)
        up('resumenContrato', s.resumenContrato.toUpperCase())
        up('fechaVencimientoContrato', s.fechaVencimientoContrato)
        up('rentaMensual', s.rentaMensual || '')
        up('notas', s.notas.toUpperCase()); up('formaPago', s.formaPago)
        up('noCuenta', s.noCuenta.toUpperCase())
        up('arrendadorName', s.arrendadorName.toUpperCase())
        up('idArrendadorFile', s.idArrendadorFile)
        up('propietarioIntermediario', s.propietarioIntermediario)
        up('documentoAcreditacionPosesionFile', s.documentoAcreditacionPosesionFile)
        up('fechaInactivo', s.fechaInactivo); up('fechaAlta', s.fechaAlta)

        const ok = r => {
            if (r.data.message === 'saved') {
                this.props.history.push(`/domicilios/reportes/${r.data.id}`)
            } else {
                alert(r.data.message)
                this.setState({ loading: false })
            }
        }
        if (Number(s.id) === -1) {
            ElementsDataService.createElement("domicilios", fd).then(ok)
        } else {
            ElementsDataService.updateElement("domicilios", s.id, fd).then(ok)
        }
    }

    set = f => e => this.setState({ [f]: e.target.value, errors: { ...this.state.errors, [f]: null } })
    setUpper = f => e => this.setState({ [f]: e.target.value.toUpperCase(), errors: { ...this.state.errors, [f]: null } })

    render() {
        const { calle, tipoVialidad, colonia, cp, estado, municipio, numeroExt, numeroInterior,
            telefono, estatus, control, tipo, tipoInmueble, referencias, especificaciones,
            entreCalle1, entreCalle2, contratoArrendamientoFile, comprobanteDomicilioFile,
            croquisFile, resumenContrato, fechaVencimientoContrato, rentaMensual, notas,
            formaPago, noCuenta, arrendadorName, idArrendadorFile, propietarioIntermediario,
            documentoAcreditacionPosesionFile, fechaInactivo, fechaAlta,
            loading, errors } = this.state

        const isNew = Number(this.state.id) === -1
        const titulo = calle ? `${calle.toUpperCase()} ${numeroExt.toUpperCase()}${numeroInterior ? ' - ' + numeroInterior.toUpperCase() : ''}` : 'Nuevo Domicilio'

        return (
            <div style={S.root}>
                <style>{`
                    @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap');
                    .dff * { font-family: 'Inter', sans-serif; box-sizing: border-box; }
                    .dff-input {
                        width: 100%; padding: 9px 13px;
                        background: white; border: 1px solid #e2e8f0; border-radius: 10px;
                        font-size: 0.875rem; color: #1e293b; outline: none; transition: all 0.2s;
                        font-family: 'Inter', sans-serif; text-transform: uppercase;
                    }
                    .dff-input.no-upper { text-transform: none; }
                    .dff-input:focus { border-color: #3b82f6; box-shadow: 0 0 0 3px rgba(59,130,246,0.1); }
                    .dff-input.err { border-color: #ef4444; box-shadow: 0 0 0 3px rgba(239,68,68,0.08); }
                    .dff-input:disabled { background: #f8fafc; color: #94a3b8; cursor: not-allowed; }
                    .dff-select {
                        width: 100%; padding: 9px 32px 9px 13px; appearance: none;
                        background: white; border: 1px solid #e2e8f0; border-radius: 10px;
                        font-size: 0.875rem; color: #1e293b; outline: none; cursor: pointer;
                        transition: all 0.2s; font-family: 'Inter', sans-serif;
                        background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='10' height='10' viewBox='0 0 12 12'%3E%3Cpath fill='%2394a3b8' d='M6 8L1 3h10z'/%3E%3C/svg%3E");
                        background-repeat: no-repeat; background-position: right 11px center;
                    }
                    .dff-select:focus { border-color: #3b82f6; box-shadow: 0 0 0 3px rgba(59,130,246,0.1); }
                    .dff-select.err { border-color: #ef4444; }
                    .dff-textarea {
                        width: 100%; padding: 9px 13px; min-height: 72px; resize: vertical;
                        background: white; border: 1px solid #e2e8f0; border-radius: 10px;
                        font-size: 0.875rem; color: #1e293b; outline: none; transition: all 0.2s;
                        font-family: 'Inter', sans-serif; text-transform: uppercase; line-height: 1.6;
                    }
                    .dff-textarea:focus { border-color: #3b82f6; box-shadow: 0 0 0 3px rgba(59,130,246,0.1); }
                    .dff-label { font-size: 0.68rem; font-weight: 700; color: #64748b; letter-spacing: 0.8px; text-transform: uppercase; display: block; margin-bottom: 5px; }
                    .dff-err { font-size: 0.72rem; color: #ef4444; margin-top: 4px; }
                    .dff-file-zone {
                        border: 1.5px dashed #e2e8f0; border-radius: 10px; padding: 14px 16px;
                        background: #f8fafc; transition: all 0.2s;
                    }
                    .dff-file-zone:hover { border-color: #3b82f6; background: #eff6ff; }
                    .dff-file-label { font-size: 0.8rem; color: #64748b; display: flex; align-items: center; gap: 8px; }
                    .dff-file-name { font-size: 0.75rem; color: #3b82f6; margin-top: 4px; word-break: break-all; }
                    .btn-save {
                        padding: 11px 28px; background: linear-gradient(135deg, #2563eb, #3b82f6);
                        border: none; border-radius: 10px; color: white; font-weight: 700;
                        font-size: 0.88rem; cursor: pointer; transition: all 0.2s;
                        font-family: 'Inter', sans-serif; box-shadow: 0 4px 14px rgba(59,130,246,0.3);
                    }
                    .btn-save:hover:not(:disabled) { transform: translateY(-1px); box-shadow: 0 6px 18px rgba(59,130,246,0.4); }
                    .btn-save:disabled { opacity: 0.6; cursor: not-allowed; }
                    .btn-cancel {
                        padding: 11px 20px; background: white; border: 1px solid #e2e8f0;
                        border-radius: 10px; color: #64748b; font-weight: 600; font-size: 0.88rem;
                        cursor: pointer; transition: all 0.2s; font-family: 'Inter', sans-serif;
                    }
                    .btn-cancel:hover { border-color: #94a3b8; color: #334155; }
                    .currency-wrap input {
                        width: 100%; padding: 9px 13px;
                        background: white; border: 1px solid #e2e8f0; border-radius: 10px;
                        font-size: 0.875rem; color: #1e293b; outline: none; transition: all 0.2s;
                        font-family: 'Inter', sans-serif;
                    }
                    .currency-wrap input:focus { border-color: #3b82f6; box-shadow: 0 0 0 3px rgba(59,130,246,0.1); }
                    .currency-wrap input:disabled { background: #f8fafc; color: #94a3b8; cursor: not-allowed; }
                `}</style>

                <div className="dff" style={S.inner}>

                    {/* Header */}
                    <div style={S.header}>
                        <div>
                            <p style={S.breadcrumb}>
                                <span style={{ color: '#3b82f6', cursor: 'pointer' }} onClick={() => this.props.history.push('/domicilios')}>Domicilios</span>
                                <span style={{ margin: '0 8px', color: '#cbd5e1' }}>›</span>
                                <span>{titulo}</span>
                            </p>
                            <h1 style={S.title}>{isNew ? 'Nuevo Domicilio' : titulo}</h1>
                        </div>
                        <div style={{ display: 'flex', gap: 10 }}>
                            <button className="btn-cancel" onClick={() => this.props.history.goBack()}>Cancelar</button>
                            <button className="btn-save" onClick={this.onSubmit} disabled={loading}>
                                {loading ? '⏳ Guardando...' : '✓ Guardar'}
                            </button>
                        </div>
                    </div>

                    <Formik initialValues={{}} onSubmit={this.onSubmit} enableReinitialize>
                        {() => (
                            <Form autoComplete="off">

                                {/* ── 1. DIRECCIÓN ── */}
                                <Section icon="📍" title="Dirección">
                                    <Grid cols={4}>
                                        <Field label="Tipo Vialidad">
                                            <select className="dff-select" value={tipoVialidad} onChange={this.set('tipoVialidad')}>
                                                <option value="Calle">Calle</option>
                                                <option value="Avenida">Avenida</option>
                                                <option value="Boulevard">Boulevard</option>
                                                <option value="Calzada">Calzada</option>
                                                <option value="Privada">Privada</option>
                                            </select>
                                        </Field>
                                        <Field label={tipoVialidad + ' *'} error={errors.calle}>
                                            <input className={`dff-input${errors.calle ? ' err' : ''}`} value={calle} onChange={this.setUpper('calle')} placeholder="NOMBRE DE LA VIALIDAD" autoComplete="off" />
                                        </Field>
                                        <Field label="Núm. Exterior *" error={errors.numeroExt}>
                                            <input className={`dff-input${errors.numeroExt ? ' err' : ''}`} value={numeroExt} onChange={this.setUpper('numeroExt')} placeholder="EJ: 123" autoComplete="off" />
                                        </Field>
                                        <Field label="Núm. Interior">
                                            <input className="dff-input" value={numeroInterior} onChange={this.setUpper('numeroInterior')} placeholder="EJ: A / PISO 2" autoComplete="off" />
                                        </Field>
                                    </Grid>
                                    <Grid cols={3}>
                                        <Field label="Entre Calle 1">
                                            <input className="dff-input" value={entreCalle1} onChange={this.setUpper('entreCalle1')} placeholder="" autoComplete="off" />
                                        </Field>
                                        <Field label="Entre Calle 2">
                                            <input className="dff-input" value={entreCalle2} onChange={this.setUpper('entreCalle2')} placeholder="" autoComplete="off" />
                                        </Field>
                                        <Field label="Colonia *" error={errors.colonia}>
                                            <input className={`dff-input${errors.colonia ? ' err' : ''}`} value={colonia} onChange={this.setUpper('colonia')} placeholder="COLONIA" autoComplete="off" />
                                        </Field>
                                    </Grid>
                                    <Grid cols={4}>
                                        <Field label="Municipio *" error={errors.municipio}>
                                            <input className={`dff-input${errors.municipio ? ' err' : ''}`} value={municipio} onChange={this.setUpper('municipio')} placeholder="MUNICIPIO" autoComplete="off" />
                                        </Field>
                                        <Field label="Estado *" error={errors.estado}>
                                            <input className={`dff-input${errors.estado ? ' err' : ''}`} value={estado} onChange={this.setUpper('estado')} placeholder="ESTADO" autoComplete="off" />
                                        </Field>
                                        <Field label="Código Postal *" error={errors.cp}>
                                            <input className={`dff-input no-upper${errors.cp ? ' err' : ''}`} value={cp} onChange={this.set('cp')} placeholder="00000" autoComplete="off" maxLength={5} />
                                        </Field>
                                        <Field label="Teléfono">
                                            <input className="dff-input no-upper" value={telefono} onChange={this.set('telefono')} placeholder="(000) 000-0000" autoComplete="off" />
                                        </Field>
                                    </Grid>
                                    <Grid cols={2}>
                                        <Field label="Referencias">
                                            <textarea className="dff-textarea" value={referencias} onChange={this.setUpper('referencias')} placeholder="Referencias para llegar al domicilio..." />
                                        </Field>
                                        <Field label="Especificaciones">
                                            <textarea className="dff-textarea" value={especificaciones} onChange={this.setUpper('especificaciones')} placeholder="Especificaciones del inmueble..." />
                                        </Field>
                                    </Grid>
                                </Section>

                                {/* ── 2. CLASIFICACIÓN ── */}
                                <Section icon="🏷️" title="Clasificación">
                                    <Grid cols={4}>
                                        <div>
                                            <Field label="Estatus *" error={errors.estatus}>
                                                <select className={`dff-select${errors.estatus ? ' err' : ''}`} value={estatus} onChange={this.set('estatus')}>
                                                    <option value="">— Seleccionar —</option>
                                                    <option value="ACTIVO">ACTIVO</option>
                                                    <option value="INACTIVO">INACTIVO</option>
                                                </select>
                                            </Field>
                                            {estatus === 'INACTIVO' && (
                                                <div style={{ marginTop: 10 }}>
                                                    <Field label="Fecha de Baja">
                                                        <input className="dff-input no-upper" type="date" value={fechaInactivo} onChange={this.set('fechaInactivo')} />
                                                    </Field>
                                                </div>
                                            )}
                                            {estatus === 'ACTIVO' && (
                                                <div style={{ marginTop: 10 }}>
                                                    <Field label="Fecha de Alta">
                                                        <input className="dff-input no-upper" type="date" value={fechaAlta} onChange={this.set('fechaAlta')} />
                                                    </Field>
                                                </div>
                                            )}
                                        </div>
                                        <Field label="Control *" error={errors.control}>
                                            <select className={`dff-select${errors.control ? ' err' : ''}`} value={control} onChange={this.set('control')}>
                                                <option value="">— Seleccionar —</option>
                                                <option value="CONTROL">CONTROL</option>
                                                <option value="NO CONTROL">NO CONTROL</option>
                                            </select>
                                        </Field>
                                        <Field label="Tipo *" error={errors.tipo}>
                                            <select className={`dff-select${errors.tipo ? ' err' : ''}`} value={tipo} onChange={this.set('tipo')}>
                                                <option value="">— Seleccionar —</option>
                                                <option value="FISICO">FÍSICO</option>
                                                <option value="VIRTUAL">VIRTUAL</option>
                                                <option value="DEL CLIENTE">DEL CLIENTE</option>
                                            </select>
                                        </Field>
                                        <Field label="Tipo Inmueble">
                                            <input className="dff-input" value={tipoInmueble} onChange={this.setUpper('tipoInmueble')} placeholder="OFICINA, BODEGA..." autoComplete="off" />
                                        </Field>
                                    </Grid>
                                    <Grid cols={1}>
                                        <Field label="Notas">
                                            <textarea className="dff-textarea" value={notas} onChange={this.setUpper('notas')} placeholder="Notas adicionales..." />
                                        </Field>
                                    </Grid>
                                </Section>

                                {/* ── 3. CONTRATO Y RENTA ── */}
                                <Section icon="📄" title="Contrato y Renta">
                                    <Grid cols={1}>
                                        <Field label="Resumen del Contrato de Arrendamiento">
                                            <textarea className="dff-textarea" style={{ minHeight: 90 }} value={resumenContrato} onChange={this.setUpper('resumenContrato')} placeholder="Resumen de condiciones y términos del contrato..." />
                                        </Field>
                                    </Grid>
                                    <Grid cols={4}>
                                        <Field label="Vigencia del Contrato">
                                            <input className="dff-input no-upper" type="date" value={fechaVencimientoContrato} onChange={this.set('fechaVencimientoContrato')} />
                                        </Field>
                                        <div>
                                            <label className="dff-label">Renta Mensual{control === 'NO CONTROL' ? ' (N/A)' : ''}</label>
                                            <div className="currency-wrap">
                                                <CurrencyInput
                                                    id="rentaMensual"
                                                    name="rentaMensual"
                                                    prefix="$"
                                                    disabled={control === 'NO CONTROL'}
                                                    value={rentaMensual}
                                                    decimalsLimit={2}
                                                    onValueChange={v => this.setState({ rentaMensual: v })}
                                                />
                                            </div>
                                        </div>
                                        <Field label="Forma de Pago">
                                            <select className="dff-select" value={formaPago} onChange={this.set('formaPago')}>
                                                <option value="">— Seleccionar —</option>
                                                <option value="EFECTIVO">EFECTIVO</option>
                                                <option value="TRANSFERENCIA">TRANSFERENCIA</option>
                                            </select>
                                        </Field>
                                        <Field label="Número de Cuenta">
                                            <input className="dff-input" value={noCuenta} onChange={this.setUpper('noCuenta')} placeholder="CLABE / NO. CUENTA" autoComplete="off" />
                                        </Field>
                                    </Grid>
                                    {/* Archivo contrato */}
                                    <Grid cols={1}>
                                        <FileField
                                            label="Contrato de Arrendamiento"
                                            existing={contratoArrendamientoFile}
                                            onChange={f => this.setState({ contratoArrendamientoFile: f })}
                                            id="file-contrato"
                                        />
                                    </Grid>
                                </Section>

                                {/* ── 4. ARRENDADOR Y DOCUMENTOS ── */}
                                <Section icon="🤝" title="Arrendador y Documentos">
                                    <Grid cols={2}>
                                        <Field label="Nombre del Arrendador">
                                            <input className="dff-input" value={arrendadorName} onChange={this.setUpper('arrendadorName')} placeholder="NOMBRE COMPLETO" autoComplete="off" />
                                        </Field>
                                        <Field label="Rol del Arrendador">
                                            <select className="dff-select" value={propietarioIntermediario} onChange={this.set('propietarioIntermediario')}>
                                                <option value="">— Seleccionar —</option>
                                                <option value="PROPIETARIO">PROPIETARIO</option>
                                                <option value="INTERMEDIARIO">INTERMEDIARIO</option>
                                            </select>
                                        </Field>
                                    </Grid>
                                    <Grid cols={3}>
                                        <FileField
                                            label="Identificación del Arrendador"
                                            existing={idArrendadorFile}
                                            onChange={f => this.setState({ idArrendadorFile: f })}
                                            id="file-id-arrendador"
                                        />
                                        <FileField
                                            label="Documento que Acredita Posesión"
                                            existing={documentoAcreditacionPosesionFile}
                                            onChange={f => this.setState({ documentoAcreditacionPosesionFile: f })}
                                            id="file-acreditacion"
                                        />
                                        <FileField
                                            label="Comprobante de Domicilio"
                                            existing={comprobanteDomicilioFile}
                                            onChange={f => this.setState({ comprobanteDomicilioFile: f })}
                                            id="file-comprobante"
                                        />
                                    </Grid>
                                    <Grid cols={1}>
                                        <FileField
                                            label="Croquis"
                                            existing={croquisFile}
                                            onChange={f => this.setState({ croquisFile: f })}
                                            id="file-croquis"
                                        />
                                    </Grid>
                                </Section>

                                {/* Footer */}
                                <div style={S.footer}>
                                    <button type="button" className="btn-cancel" onClick={() => this.props.history.goBack()}>Cancelar</button>
                                    <button type="button" className="btn-save" onClick={this.onSubmit} disabled={loading}>
                                        {loading ? '⏳ Guardando...' : '✓ Guardar Domicilio'}
                                    </button>
                                </div>
                            </Form>
                        )}
                    </Formik>
                </div>
            </div>
        )
    }
}

/* ── Componentes auxiliares ── */
const Section = ({ icon, title, children }) => (
    <div style={{ background: 'white', border: '1px solid #e8edf5', borderRadius: 16, marginBottom: 16, overflow: 'hidden', boxShadow: '0 2px 8px rgba(0,0,0,0.04)' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '13px 22px', borderBottom: '1px solid #f1f5f9', background: '#fafcff' }}>
            <span>{icon}</span>
            <h2 style={{ margin: 0, fontSize: '0.9rem', fontWeight: 700, color: '#1e293b' }}>{title}</h2>
        </div>
        <div style={{ padding: '18px 22px' }}>{children}</div>
    </div>
)

const Grid = ({ cols, children }) => (
    <div style={{ display: 'grid', gridTemplateColumns: `repeat(${cols}, 1fr)`, gap: 14, marginBottom: 14 }}>
        {children}
    </div>
)

const Field = ({ label, error, children }) => (
    <div>
        <label className="dff-label">{label}</label>
        {children}
        {error && <p className="dff-err">⚠ {error}</p>}
    </div>
)

const FileField = ({ label, existing, onChange, id }) => {
    const isUrl = typeof existing === 'string' && existing.startsWith('http')
    const isFile = existing && existing.name
    return (
        <div>
            <label className="dff-label">📎 {label}</label>
            <div
                className="dff-file-zone"
                onClick={() => document.getElementById(id).click()}
                style={{ cursor: 'pointer' }}
            >
                <div className="dff-file-label">
                    <span style={{ fontSize: '1.1rem' }}>📁</span>
                    <span style={{ color: isFile ? '#3b82f6' : '#94a3b8' }}>
                        {isFile ? existing.name : 'Seleccionar archivo...'}
                    </span>
                </div>
                {isUrl && (
                    <div style={{ marginTop: 6 }}>
                        <a href={existing} target="_blank" rel="noopener noreferrer"
                            style={{ fontSize: '0.75rem', color: '#3b82f6', textDecoration: 'none' }}
                            onClick={e => e.stopPropagation()}>
                            📄 Ver archivo actual ↗
                        </a>
                    </div>
                )}
            </div>
            <input
                id={id}
                type="file"
                style={{ display: 'none' }}
                onChange={e => e.currentTarget.files[0] && onChange(e.currentTarget.files[0])}
            />
        </div>
    )
}

const S = {
    root: { minHeight: '100vh', background: '#f1f5f9', padding: '28px', fontFamily: "'Inter', sans-serif" },
    inner: { maxWidth: 960, margin: '0 auto' },
    header: { display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', marginBottom: 22, flexWrap: 'wrap', gap: 12 },
    breadcrumb: { margin: '0 0 4px', fontSize: '0.78rem', color: '#94a3b8' },
    title: { margin: 0, fontSize: '1.45rem', fontWeight: 700, color: '#0f172a' },
    footer: { display: 'flex', justifyContent: 'flex-end', gap: 10, marginBottom: 24 },
}

export default DomicilioFormularioComponent
